import { Button, Col, Form, Modal, Row, Tooltip } from "antd";
import { useState } from "react";
import { DeleteOutlined, UndoOutlined } from '@ant-design/icons';
import { useTranslation } from "react-i18next";
import userEventApi from "api/userEvent";

export default function ModalDelete({ row, onSearch, openNotificationWithIcon }) {
  const [openModal, setOpenModal] = useState(false);
  const [form] = Form.useForm();

  const { t } = useTranslation()

  const onFinish = async () => {
    try {
      await userEventApi.update(row._id, { isConfirmQr: false });
      onSearch();
      onCancel();
      openNotificationWithIcon("success", t('notification'), t('success'));
    } catch (error) {
      openNotificationWithIcon("error", t('error'), error?.response?.data?.message || t('hasError'));
    }
  };

  const onCancel = () => {
    setOpenModal(false);
    form.resetFields();
  };

  return (
    <>
      <Tooltip title={t('reset')}>
        <Button onClick={() => setOpenModal(true)}>
          <UndoOutlined />
        </Button>
      </Tooltip>

      <Modal
        open={openModal}
        title={t('reset')}
        centered
        footer={null}
        onCancel={onCancel}
        width={400}
        destroyOnClose
      >
        <Form form={form} onFinish={onFinish} layout="vertical">
          <h2 style={{ color: 'red' }}>{t('sureToReset')}</h2>
          <Row gutter={16}>
            <Col span={8} offset={4}>
              <Form.Item>
                <Button danger style={{ width: "100%" }} htmlType="submit">
                  Ok
                </Button>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Button style={{ width: "100%" }} onClick={onCancel}>
                {t('cancel')}
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
}
